import React, { useEffect, useState } from 'react';
import './index.scss';

/**
 * 全屏烟花效果组件 - 性能优化版本
 * 使用纯CSS动画，避免频繁JS操作，降低内存占用
 * 
 * @param {boolean} visible - 是否显示烟花效果
 * @param {number} duration - 动画持续时间（毫秒），默认2000ms
 */
const Fireworks = ({ visible = false, duration = 3000 }) => {
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        if (visible) {
            setShouldRender(true);
            // 动画结束后自动清理，释放内存（延长到3秒，让庆祝效果更完整）
            const timer = setTimeout(() => {
                setShouldRender(false);
            }, duration);
            return () => clearTimeout(timer);
        } else {
            setShouldRender(false);
        }
    }, [visible, duration]);

    if (!shouldRender) return null;

    return (
        <div className="fireworks-container">
            {/* 使用伪元素和少量DOM节点实现烟花效果 - 每个烟花用多个伪元素创建更多粒子 */}
            <div className="firework firework-1"></div>
            <div className="firework firework-2"></div>
            <div className="firework firework-3"></div>
            <div className="firework firework-4"></div>
            <div className="firework firework-5"></div>
            <div className="firework firework-6"></div>
            <div className="firework firework-7"></div>
            <div className="firework firework-8"></div>
            <div className="firework firework-9"></div>
            <div className="firework firework-10"></div>
            <div className="firework firework-11"></div>
            <div className="firework firework-12"></div>
            {/* 闪烁星星效果 */}
            <div className="sparkle sparkle-1"></div>
            <div className="sparkle sparkle-2"></div>
            <div className="sparkle sparkle-3"></div>
            <div className="sparkle sparkle-4"></div>
            <div className="sparkle sparkle-5"></div>
            <div className="sparkle sparkle-6"></div>
        </div>
    );
};

export default Fireworks;
